import { render, staticRenderFns } from "./mHzzx.vue?vue&type=template&id=1064ce5c&scoped=true&"
import script from "./mHzzx.vue?vue&type=script&lang=js&"
export * from "./mHzzx.vue?vue&type=script&lang=js&"
import style0 from "./mHzzx.vue?vue&type=style&index=0&id=1064ce5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1064ce5c",
  null
  
)

export default component.exports